export default __webpack_public_path__ + "static/media/location-map.b4b5bca8.png";